import styled from 'styled-components';

import { colorGrey400, fontFamilyPrimary } from '@/styleUtils';

export const Note = styled.div`
  font: normal 400 13px/16px ${fontFamilyPrimary};
  color: ${colorGrey400};
  letter-spacing: 0.13px;
`;

export default Note;
